import axios from 'axios'
import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'

export function useBpmCheckout ({
  policy,
  mode,
  notify,
  sharedApi,
  changeDisabled,
  globalLoader,
}) {
  function calculate () {
    changeDisabled.value = true
    axios.post(mode.value.calculateUrl, { policy })
      .then(res => {
        if (res.data.result) {
          policy.premium = res.data.premium
          policy.calculationDate = res.data.calculationDate
          policy.premiumCalculation = { ...res.data }
        } else {
          notify.error(res.data)
        }
      })
      .catch(err => {
        notify.error(err)
      })
      .finally(() => {
        changeDisabled.value = false
      })
  }

  function checkout () {
    if (!BpmOsgpoModule.Validator.canCheckout(policy, mode.value)) {
      const hint = BpmOsgpoModule.Validator.getWizardNextStepHint(2, policy, mode.value)
      if (hint.message) {
        notify.error({ message: hint.message })
      }
      return
    }
    changeDisabled.value = true
    globalLoader.value = true
    const data = structuredClone(policy)
    delete data.business_process
    sharedApi.addProcess(5, { policy: data })
  }

  return {
    calculate,
    checkout,
  }
}
